/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HousingApplicationMigrationResultDto } from '../models/HousingApplicationMigrationResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class HousingApplicationMigrationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param sysOrgGuid
     * @param pageNumber
     * @param pageSize
     * @param dryRun
     * @returns HousingApplicationMigrationResultDto OK
     * @throws ApiError
     */
    public migrateHousingApplicationsToEntities(
        sysOrgGuid: string,
        pageNumber: number = 1,
        pageSize: number = 100,
        dryRun: boolean = false,
    ): CancelablePromise<HousingApplicationMigrationResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingApplicationMigration/{sysOrgGuid}/MigrateHousingApplicationsToEntities',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'dryRun': dryRun,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
